export default __webpack_public_path__ + "static/media/joshua-earles.82fee51f.jpg";